import type { Api } from "../../../services/api";

type InfographicListItem = Extract<
  Api["get"]["/webapp/public/content"]["output"]["body"]["docs"][number],
  { content_format: "Infographic" }
>;
type InfographicDetail = Extract<
  Api["get"]["/webapp/public/content/:id"]["output"]["body"],
  { content_format: "Infographic" }
>;
import {
  AnalyticsItemCategory,
  AnalyticsItemVariant,
} from "../analytics.types";
import { gaPushEvent } from "../base.analytics";
import {
  AnalyticsItemReturnData,
  gaEventSelectItem,
  gaEventViewItem,
} from "../common.analytics";
import type { CongressAttribution } from "../../../domains/congress/congressAttribution";

type RoomInfographicItem = Extract<
  Api["get"]["/webapp/private/content/last-in-user-room"]["output"]["body"][number],
  { content_format: "Infographic" }
>;

type InfographicAnalyticsData =
  InfographicListItem | InfographicDetail | RoomInfographicItem;

type InfographicItemPayload = {
  infographic: InfographicAnalyticsData;
  listName: string;
};

export function convertInfographicToItemData(
  payload: InfographicItemPayload
): AnalyticsItemReturnData {
  const { infographic, listName } = payload;
  return {
    item_id: infographic.id,
    item_name: infographic.title,
    item_brand: infographic.company?.name ?? null,
    item_category: (infographic.medical_specialties ?? [])
      .map((spe) => spe.uid)
      .join(","),
    item_category2: AnalyticsItemCategory.STANDARD,
    item_variant: AnalyticsItemVariant.INFOGRAPHIC,
    item_list_name: listName,
  };
}

export function gaEventSelectItemInfographic(payload: InfographicItemPayload) {
  gaEventSelectItem(convertInfographicToItemData(payload));
}

export function gaEventViewItemInfographic(
  payload: InfographicItemPayload,
  congress: CongressAttribution | null
) {
  gaEventViewItem(convertInfographicToItemData(payload), congress);
}

enum InfographicEvent {
  INFOGRAPHIC_LIKE = "infographic_like",
  INFOGRAPHIC_SAVE = "infographic_save",
  INFOGRAPHIC_SHARE = "infographic_share",
}

export function gaEventInfographicLike(payload: InfographicItemPayload) {
  gaPushEvent(InfographicEvent.INFOGRAPHIC_LIKE, {
    ecommerce: { items: [convertInfographicToItemData(payload)] },
  });
}

export function gaEventInfographicSave(payload: InfographicItemPayload) {
  gaPushEvent(InfographicEvent.INFOGRAPHIC_SAVE, {
    ecommerce: { items: [convertInfographicToItemData(payload)] },
  });
}

export function gaEventInfographicShare(payload: InfographicItemPayload) {
  gaPushEvent(InfographicEvent.INFOGRAPHIC_SHARE, {
    ecommerce: { items: [convertInfographicToItemData(payload)] },
  });
}
